<template>
  <v-row>
    <v-col>
      <ReportHeading
        label="Баланс Оплат/Послуг за Пакетами"
        :loading="loading"
        class="no-print"
        @update-report="updateReport"
      >
        <template v-slot:filters>
          <v-row
            dense
            align="center"
          >
            <v-col>
              <DateRangePicker
                :start.sync="dateFrom"
                :end.sync="dateTo"
                type="month"
                :disabled="loading"
                :filled="false"
              />
            </v-col>
            <slot />
          </v-row>
        </template>
      </ReportHeading>

      <BalancePrintForm
        :items="reports"
        :filter="filter"
        :total-start-month-balance="totalStartMonthBalance"
        :total-payed-hours="totalPayedHours"
        :total-spent-hours="totalSpentHours"
        :total-bonus-hours="totalBonusHours"
        :total-end-month-balance="totalEndMonthBalance"
        :total-services-hours="totalServicesHours"
        :hide-service-hours-column="hideServiceHoursColumn"
      />
    </v-col>
  </v-row>
</template>

<script>
import BalancePrintForm from "@/views/reports/balance/PrintForm.vue";
import * as clientDashboard from "@/backend/clientDashboardApi.js";
import ReportHeading from "@/components/ReportHeading.vue";
import DateRangePicker from "@/components/story/DateRangePicker.vue";

export default {
  components: {
    BalancePrintForm,
    ReportHeading,
    DateRangePicker,
  },
  data: () => ({
    loading: false,
    reports: [],
    dateFrom: "",
    dateTo: "",
  }),
  computed: {
    filter() {
      return {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      };
    },
    filterClean(){
      return !this.dateFrom && !this.dateTo;
    },
    totalStartMonthBalance() {
      if (this.reports.length) {
        return this.reports[0].startMonthBalance;
      } else {
        return 0;
      }
    },
    totalPayedHours() {
      return this.reports.reduce((sum, current) => {
        return sum + current.payedHours;
      }, 0);
    },
    totalSpentHours() {
      return this.reports.reduce((sum, current) => {
        return sum + current.spentHours;
      }, 0);
    },
    totalBonusHours() {
      return this.reports.reduce((sum, current) => {
        return sum + current.bonusHours;
      }, 0);
    },
    totalServicesHours() {
      return this.reports.reduce((sum, current) => {
        return sum + current.servicesHours;
      }, 0);
    },
    totalEndMonthBalance() {
      return (
        Math.round(
          (this.totalStartMonthBalance +
            this.totalPayedHours -
            this.totalServicesHours +
            this.totalBonusHours -
            this.totalSpentHours) *
            100
        ) / 100
      );
    },
    hideServiceHoursColumn() {
      return this.reports.every(({ servicesHours }) => servicesHours === 0);
    },
  },
  watch: {
    filter() {
      if (this.filterClean){
        this.reports = [];
      } else {
        this.updateReport();
      }
    },
  },
  created() {
    this.dateTo = this.moment().format("YYYY-MM");
    this.dateFrom = this.moment().subtract(2, "month").format("YYYY-MM");
  },
  methods: {
    async updateReport() {
      this.loading = true;
      this.reports = [];
      const filterParams = {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      };

      try {
        this.reports = await clientDashboard
          .balanceUpdateReport(filterParams);
      } catch {
        this.$notifyWarning("В даних звіту помилки");
      }

      this.loading = false;
    },
  },
};
</script>
